"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.abstractIconProps = void 0;
const _composables_1 = require("../../_composables");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.abstractIconProps = {
    ..._composables_1.hasSizeProp,
    /**
     * The name (identifier) of the icon we want to render.
     */
    name: {
        type: String,
        required: true
    }
};
//# sourceMappingURL=Icon.hooks.js.map